module.exports = __webpack_public_path__ + "static/media/bieu_mau_03_lay_y_kiem_gv_trong_to.5c8c27d5.xlsx";